'use client'
import { Form, FormControl, FormField, FormItem, FormMessage } from "../ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { useForm } from 'react-hook-form'
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { useRouter } from "next/navigation";
import axios from 'axios';
import { useEffect } from "react";


function SymptomsForm({blogInternal, lang}) {
    // console.log(lang, 'the dsca contact lang')
    const hindiEngRegex = /^[A-Za-z\s\u0900-\u097F]+$/; // Range for both English and Hindi Unicode characters
    const formSchema = z.object({
        name: z.string().min(2, {
            message: blogInternal.form.validation.namekey1,
        }).max(20, {
            message:  blogInternal.form.validation.namekey2,
        }).refine((value) => hindiEngRegex.test(value), {
            message: blogInternal.form.validation.namekey3,
        }),

        email: z.string()
            .nonempty({
            message: blogInternal.form.validation.mailkey1
            })
            .email({
            message: blogInternal.form.validation.mailkey2,
            }),

        phone: z.string().refine((value) => /^[0-9]{10}$/.test(value), {
            message: blogInternal.form.validation.phonekey,
        }),
        message: z.string(),
    });


    const router = useRouter();
    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            name: "",
            email: "",
            phone: "",
            message:'',
        },
        }
    );
        
    useEffect(()=>{
        router.refresh()
    }, [])
    
    const onSubmit = async (data) => {
        try {
            const apiUrl = `${process.env.NEXT_PUBLIC_API_URL}/symptoms-forms`;
            // Strapi API endpoint
    
        const patientsData = {
            Name: data.name,
            Email: data.email,
            Phone: data.phone,
            Message: data.message ? data.message : 'no message',
            formName: "Symptoms Form",
            source:"Website",
        };
            // console.log(patientsData,'kk')
    
        // Strapi API endpoint
        try {
            const response = await axios.post(apiUrl, { data: patientsData }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response && response.status === 200) {

                const responseData = response.data;
                // console.log(responseData)
                // alert('Strapi Success:ForothersDesktop'+ responseData);
            } else {
                console.error('Failed to submit form');
            }   
        } catch (error) {
            console.error('Error:', error);
        }
        
    
        // Clear the form after submission
        form.reset();
        // router.push('/symptoms/thank-you');
        if (lang==='en') {
            router.push('/symptoms/thank-you');
        } else {
            router.push(`/${lang}/symptoms/thank-you`);
        }
        } catch (error) {
        console.error('Error:', error);
        }
    };

    return (
        <Form className="bg-primaryBlue p-9 rounded-3xl" {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="text-white text-lg bg-primaryBlue lg:p-9 rounded-3xl p-4">
                <h3 className="header-sub text-white mb-6">{blogInternal.form.symptomstitle}</h3>
                <FormField control={form.control} name="name" render={({ field }) => (
                    <FormItem className='space-y-0 mt-2'>
                        <Label className='block mb-2 p-text'>{blogInternal.form.name}*</Label>
                        <FormControl>
                            <Input type="text" className="block w-full h-12 p-2.5 bg-blue-50 rounded-lg mb-4 text-primaryGreyText" placeholder="" {...field} />
                        </FormControl>
                        <FormMessage className="absolute pt-1"/>
                    </FormItem>
                )}
                />
                <FormField control={form.control} name="email" render={({ field }) => (
                    <FormItem className=' space-y-0 mt-8'>
                        <Label className='block mb-2 p-text'>{blogInternal.form.mail}*</Label>
                        <FormControl>
                            <Input type="email" className="block w-full h-12 p-2.5 rounded-lg mb-4 text-primaryGreyText bg-blue-50 !important" placeholder="" {...field} />
                        </FormControl>
                        <FormMessage className="absolute pt-1"/>
                    </FormItem>
                )}
                />
                <FormField control={form.control} name="phone" render={({ field }) => (
                    <FormItem className=' space-y-0 mt-8'>
                        <Label className='block mb-2 p-text'>{blogInternal.form.phone}*</Label>
                        <FormControl>
                            <Input type="tel" className="block w-full h-12 p-2.5 bg-blue-50 rounded-lg mb-4 text-primaryGreyText" placeholder="" {...field} />
                        </FormControl>
                        <FormMessage className="absolute pt-1"/>
                    </FormItem>
                )}
                />
                <FormField control={form.control} name="message" render={({ field }) => (
                    <FormItem className=' space-y-0 mt-8'>
                        <Label className='block mb-2 p-text'>{blogInternal.form.message}</Label>
                        <FormControl>
                            <Textarea type="text" className="block w-full h-24 p-2.5 bg-blue-50 rounded-lg mb-4 text-primaryGreyText" placeholder="" {...field} />
                        </FormControl>
                        <FormMessage className="absolute pt-1"/>
                    </FormItem>
                )}
                />
                <div className='text-right mt-4'>
                    <Button  type="submit" variant="outline" className='bg-white hover:bg-blue-950 hover:text-white mt-4 w-44 h-12 rounded-3xl text-base text-primaryBlue contact-form'>{blogInternal.form.submit}</Button>
                </div>
            </form>
        </Form>
    )

};
export default SymptomsForm;